module.exports = "/call-frontend/img/icon_check_outline.6afea6a1.svg";